import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

interface DisplayCard {
  image: string;
  title: string;
  /** Star rating out of 5; 0 hides the stars. */
  stars: number;
}

const HOTELS = 'assets/images/pmax-preview-hotels/';

/**
 * Performance Max on a Display Network site (desktop): a carousel of three
 * cards in the sidebar, with the long headline under it. The hotel cards
 * are static placeholders; they are not template fields.
 */
@Component({
  selector: 'app-pmax-display-desktop-01',
  imports: [CommonModule, DesktopFrameComponent],
  templateUrl: './display-desktop-01.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-desktop-01.component.scss'
})
export class PmaxDisplayDesktop01PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton nav bars under the site name. */
  readonly navItems = [0, 1, 2, 3];

  /** Skeleton text lines above the article image, as % widths. */
  readonly articleLines = [100, 100, 100, 100, 75];

  readonly starSlots = [1, 2, 3, 4, 5];

  readonly cards: DisplayCard[] = [
    { image: HOTELS + 'pical.jpg', title: 'Pical Hotel', stars: 5 },
    { image: HOTELS + 'girandella.jpg', title: 'Valamar Girandella Resort', stars: 4 },
    { image: HOTELS + 'lanterna.jpg', title: 'Lanterna Resort', stars: 0 },
  ];

  get longHeadline(): string {
    return this.data.longHeadlines[0] || 'Your long headline appears here';
  }

  get ctaText(): string {
    return this.data.ctaText || 'Book now';
  }
}
